import {FormControl, HelperText, IconButton} from 'platform/components';
import {HStack, Icon, Link, Show, Space, VStack, Text, Spinner, Hide} from 'platform/foundation';

import i18n from '@dms/i18n';

import {Nullish, openFile} from 'shared/web';

import {getFileIcon} from '../../../utils/getFileIcon';
import {DocumentExtractionImportFile} from '../types/DocumentExtractionImportFile';
import {DocumentExtractionImportFormDefinition} from '../types/DocumentExtractionImportFormDefinition';

interface DocumentExtractionImportFileListProps {
  name: keyof DocumentExtractionImportFormDefinition;
  control: FormControl<DocumentExtractionImportFormDefinition>;
  filesToImport: DocumentExtractionImportFile[] | null;
  validationMessage: string | Nullish;
  onDelete: (fileId: string) => void;
}

export function DocumentExtractionImportFileList(props: DocumentExtractionImportFileListProps) {
  return (
    <VStack spacing={2} width="100%">
      {props.filesToImport?.map((file) => {
        const isUploadingFile = file.status === 'pending';
        return (
          <VStack key={file.fileId} spacing={0} width="100%">
            <HStack align="center" spacing={3} width="100%">
              <Icon size={8} value={getFileIcon(file.contentType)} />

              {file.fileUri ? (
                <Link
                  size="small"
                  title={file.fileName}
                  onClick={() => openFile(file.fileUri as string)}
                />
              ) : (
                <Text size="small" color={file.errorMessage ? 'danger' : 'primary'}>
                  {file.fileName}
                </Text>
              )}

              <Space fillAvailable />

              <Show when={isUploadingFile}>
                <HStack spacing={2}>
                  <Text size="xSmall" color="secondary">
                    {i18n.t('general.labels.uploading')}
                  </Text>
                  <Spinner size="small" />
                </HStack>
              </Show>

              <Hide when={isUploadingFile}>
                <IconButton
                  size="small"
                  icon="action/delete"
                  severity="danger"
                  onClick={() => props.onDelete(file.fileId as string)}
                />
              </Hide>
            </HStack>

            <Show when={file.status === 'error'}>
              <HelperText errorMessage={file.errorMessage} />
            </Show>
          </VStack>
        );
      })}
      <Show when={props.validationMessage}>
        <HelperText errorMessage={props.validationMessage} />
      </Show>
    </VStack>
  );
}
